'use es6';

export const settingsValueSelector = (state, settingsKey) => {
  const {
    settings
  } = state;
  return settings[settingsKey] ? Boolean(settings[settingsKey].value) : false;
};